import { useRef as e, useLayoutEffect as t } from "react";

import r from "./models/Select/index.js";

const o = (o, n) => {
    const s = e().current ||= new r(o, n);
    return t((() => s.set(n))), s;
};

export { o as default };
//# sourceMappingURL=useSelect.js.map
